import keymirror from 'keymirror';
import { request } from 'js/api/axios';
import { spreadApiKeys, extractApiKeys } from '../utils';
import { callApi } from '../api';
import { SCHEMAS } from '../api/schemas';

export const types = keymirror({
  ...spreadApiKeys('LIST_TEAM_CONNECTOR_CONFIGURATIONS'),
  ...spreadApiKeys('FETCH_TEAM_CONNECTOR_CONFIGURATION'),
  ...spreadApiKeys('CREATE_TEAM_CONNECTOR_CONFIGURATION'),
  ...spreadApiKeys('UPDATE_TEAM_CONNECTOR_CONFIGURATION'),
  ...spreadApiKeys('DELETE_TEAM_CONNECTOR_CONFIGURATION'),
});

export function listTeamConnectorConfigurations(teamId, queryId = null) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.LIST_TEAM_CONNECTOR_CONFIGURATIONS, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        schema: SCHEMAS.TEAM_CONNECTOR_CONFIGURATION_ARRAY,
        meta: { queryId },
      },
      dispatch
    );
  };
}

export function fetchTeamConnectorConfiguration(teamId, connectorId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.FETCH_TEAM_CONNECTOR_CONFIGURATION, types),
        request: (_data, token, currentWorkspaceId) =>
          request.get(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors/${connectorId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        schema: SCHEMAS.TEAM_CONNECTOR_CONFIGURATION,
      },
      dispatch
    );
  };
}

export function createTeamConnectorConfiguration(teamId, configurationData) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.CREATE_TEAM_CONNECTOR_CONFIGURATION, types),
        request: (data, token, currentWorkspaceId) =>
          request.post(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors`,
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: { team_connector_configuration: configurationData },
        schema: SCHEMAS.TEAM_CONNECTOR_CONFIGURATION,
      },
      dispatch
    );
  };
}

export function updateTeamConnectorConfiguration(
  teamId,
  connectorId,
  configurationData
) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.UPDATE_TEAM_CONNECTOR_CONFIGURATION, types),
        request: (data, token, currentWorkspaceId) =>
          request.put(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors/${connectorId}`,
            data,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
        data: { team_connector_configuration: configurationData },
        schema: SCHEMAS.TEAM_CONNECTOR_CONFIGURATION,
      },
      dispatch
    );
  };
}

export function deleteTeamConnectorConfiguration(teamId, connectorId) {
  return (dispatch) => {
    return callApi(
      {
        types: extractApiKeys(types.DELETE_TEAM_CONNECTOR_CONFIGURATION, types),
        request: (_data, token, currentWorkspaceId) =>
          request.delete(
            `/api/workspaces/${currentWorkspaceId}/teams/${teamId}/connectors/${connectorId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          ),
      },
      dispatch
    );
  };
}
